import { render, staticRenderFns } from "./SetupPrefixFormula.vue?vue&type=template&id=60e6d678&"
import script from "./SetupPrefixFormula.vue?vue&type=script&lang=js&"
export * from "./SetupPrefixFormula.vue?vue&type=script&lang=js&"
import style0 from "./SetupPrefixFormula.vue?vue&type=style&index=0&id=60e6d678&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports